import { isAccessDeniedError } from './isAccessDeniedError';
export const shouldIgnoreErrors = (graphQLErrors) => graphQLErrors.some(isAccessDeniedError);
